export default "__VITE_ASSET__rGQYvgSA__"